import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Listbox, Transition, Switch } from '@headlessui/react';
import { Toaster, ToastIcon, toast, resolveValue } from 'react-hot-toast';
import {
  fetchCity,
  fetchSuburb,
  fetchDeviceType,
  fetchAccountType,
} from '../api/dropdown';
import { updateTicketById } from '../api/zoho';
import SubmitModalInquiry from '../components/SubmitModalInquiry';
import SubmitModalStore from '../components/SubmitModalStore';
import { useDropdown } from '../store/dropdown-context';

const schema = yup.object().shape({
  status: yup.string().nullable(),
  requestType: yup.string().nullable(),
  accountCode: yup.string().notRequired(),
  accountType: yup.string().nullable(),
  clientName: yup.string().required(),
  phone: yup.string().required(),
  city: yup.string().nullable(),
  suburb: yup.string().nullable(),
  notes: yup.string().nullable(),
  notes2: yup.string().nullable(),
  notes3: yup.string().nullable(),
  cf_altlb: yup.string().nullable(),
  cf_nw_alastfsar: yup.string().nullable(),
  cf_nw_aljhaz: yup.string().nullable(),
  cf_nw_rmzAljhaz: yup.string().nullable(),
  updatedBy: yup.string().nullable().notRequired(),
});

const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className='transform p-4 flex bg-white rounded shadow-lg'
          enter='transition-all duration-150'
          enterFrom='opacity-0 scale-50'
          enterTo='opacity-100 scale-100'
          leave='transition-all duration-150'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-75'
        >
          <ToastIcon toast={t} />
          <p className='px-2'>{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};

const people = ['منشأ', 'تحت العمل', 'منتهي', 'ملغي'];
let citys = [
  { id: 2, name: 'مصراتة' },
  { id: 3, name: 'بنغازي' },
];
let suburbs = [
  { id: 1, name: '11يونيو' },
  { id: 2, name: 'الحي الاسلامي' },
  { id: 3, name: 'السبعة' },
];
// let deviceCodesx = [
//   {
//     deviceId: 1,
//     description: 'مكيف هومر 9',
//     name: '001.009.001.004',
//   },
//   {
//     deviceId: 2,
//     description: 'مكيف هومر فيري -HS-12F/CH-12',
//     name: '001.012.001.006',
//   },
// ];
const inquiryTypes = ['عناوين', 'ارقام هواتف', 'اسعار اجهزة'];
// let deviceTypes = [
//   { id: 1, name: 'مكيف', deviceCodes: [deviceCodesx] },
//   { id: 2, name: 'ثلاجة', deviceCodes: [] },
//   { id: 3, name: 'خلاط', deviceCodes: [] },
//   { id: 4, name: 'مروحة', deviceCodes: [] },
// ];
const requsetTypes = ['موجود', 'غير موجود'];
let accountTypes = [{ id: 1, name: 'SRV' }];

const UpdateInquiryFormScreen = () => {
  let { phoneNumber, id } = useParams();
  const { agentNameContext } = useDropdown();

  let navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);
  const [doneStore, setDoneStore] = useState(false);
  const [openStore, setOpenStore] = useState(false);
  const [error, setError] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(people[0]);
  const [selectedRequsetType, setSelectedRequsetType] = useState(
    requsetTypes[0]
  );
  const [xx, setxx] = useState('');
  const [selectedCity, setSelectedCity] = useState(citys[0]);
  const [selectedSuburb, setSelectedSuburb] = useState();
  // const [selectedDeviceType, setSelectedDeviceType] = useState(deviceTypes[0]);
  const [selectedInquiryTypes, setSelectedInquiryTypes] = useState(
    inquiryTypes[0]
  );
  const [selectedAccountType, setSelectedAccountType] = useState(
    accountTypes[0].name
  );
  const [tktSource, setTktSource] = useState("");

  const [selectedDeviceCode, setSelectedDeviceCode] = useState('');

  const onSubmit = (data, e) => {
    e.preventDefault();
    console.log(data);
    if (
      agentNameContext.length > 0 &&
      agentNameContext != undefined &&
      agentNameContext != null &&
      agentNameContext != ''
    ) {
      setValue('updatedBy', agentNameContext, {
        shouldValidate: true,
      });
    } else {
      let agentName = localStorage.getItem('agentName');
      setValue('updatedBy', agentName, {
        shouldValidate: true,
      });
    }
    setValue('city', selectedCity?.name, {
      shouldValidate: true,
    });
    // setValue('cf_nw_aljhaz', selectedDeviceType.name, {
    //   shouldValidate: true,
    // });
    setValue('cf_nw_alastfsar', selectedInquiryTypes, {
      shouldValidate: true,
    });
    setValue('suburb', selectedSuburb?.name, {
      shouldValidate: true,
    });
    setValue('status', selectedPerson, {
      shouldValidate: true,
    });
    setValue('accountType', selectedAccountType, {
      shouldValidate: true,
    });
    setValue('cf_nw_rmzAljhaz', selectedDeviceCode, {
      shouldValidate: true,
    });
    setValue('notes', location?.state?.account?.cf?.cf_mlahzat_1, {
      shouldValidate: true,
    });
    setValue('notes2', location?.state?.account?.cf?.cf_mlahzat_2, {
      shouldValidate: true,
    });
    setValue('notes3', location?.state?.account?.cf?.cf_mlahzat_3, {
      shouldValidate: true,
    });
    setTktSource(location?.state?.account?.cf?.cf_msdr_altdhkrt);
    updateTicketById(data, id, 'inquiry')
      .then((res) => {
        toast.success('تم التعديل');
        setTimeout(() => { }, 2000);
        signupHandler();
      })
      .catch((err) => {
        toast.error('حدث خطا');
        setTimeout(() => { }, 2000);
      });
  };
  const onError = (errors, e) => console.log(errors, e);

  const signupHandler = async () => {
    navigate(`/CalLlogsScreen/${phoneNumber}`);
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });
  useEffect(() => {
    // setLoadding(true);
    // setError('');
    try {
      async function fetchData() {
        const cityRes = await fetchCity();
        const suburbRes = await fetchSuburb();
        const deviceTypeRes = await fetchDeviceType();
        const accountRes = await fetchAccountType();

        if (cityRes.data.success) {
          citys = cityRes.data.data;
        }
        // if (suburbRes.data.success) {
        //   suburbs = suburbRes.data.data;
        // }
        // if (deviceTypeRes.data.success) {
        //   deviceTypes = deviceTypeRes.data.data;
        // }
        if (accountRes.data.success) {
          accountTypes = accountRes.data.data;
        }
      }
      fetchData().then((rex) => {
        if (location?.state) {
          console.log(location?.state?.account, 'account');
          setSelectedPerson(location?.state?.account?.status);
          setTktSource(location?.state?.account?.cf?.cf_msdr_altdhkrt);

          setValue('status', location?.state?.account?.status, {
            shouldValidate: true,
          });
          setSelectedAccountType(location?.state?.account?.cf?.cf_nw_alhsab);
          setValue('accountType', location?.state?.account?.cf?.cf_nw_alhsab, {
            shouldValidate: true,
          });
          console.log(location?.state?.account?.cf?.cf_nw_alhsab);
          setValue('accountCode', location?.state?.account?.contact?.id, {
            shouldValidate: true,
          });
          setSelectedAccountType(location?.state?.account?.cf?.cf_nw_alhsab);

          setValue(
            'clientName',
            location?.state?.account?.contact?.firstName +
            ' ' +
            location?.state?.account?.contact?.lastName,
            {
              shouldValidate: true,
            }
          );
          setValue('phone', location?.state?.account?.phone, {
            shouldValidate: true,
          });

          setSelectedCity(
            citys.find(
              (element) =>
                element?.name === location?.state?.account?.cf?.cf_almdynt
            )
          );
          setxx(location?.state?.account?.cf?.cf_aldahyt);
          setValue('notes', location?.state?.account?.cf?.cf_mlahzat_1, {
            shouldValidate: true,
          });
          setValue('notes2', location?.state?.account?.cf?.cf_mlahzat_2, {
            shouldValidate: true,
          });
          setValue('notes3', location?.state?.account?.cf?.cf_mlahzat_3, {
            shouldValidate: true,
          });
          setSelectedRequsetType(location?.state?.account?.cf?.cf_altlb);
          setValue('cf_altlb', location?.state?.account?.cf?.cf_altlb, {
            shouldValidate: true,
          });

          setValue(
            'cf_nw_alastfsar',
            location?.state?.account?.cf?.cf_nw_alastfsar,
            {
              shouldValidate: true,
            }
          );
          setSelectedInquiryTypes(
            location?.state?.account?.cf?.cf_nw_alastfsar
          );
          // setSelectedDeviceType(location?.state?.account?.cf?.cf_nw_aljhaz);
          setValue('cf_nw_aljhaz', location?.state?.account?.cf?.cf_nw_aljhaz, {
            shouldValidate: true,
          });
          // setValue(
          //   'cf_nw_rmzAljhaz',
          //   location?.state?.account?.cf?.cf_rmz_aljhaz,
          //   {
          //     shouldValidate: true,
          //   }
          // );
          if (
            location?.state?.account?.cf?.cf_rmz_aljhaz.includes('undefined')
          ) {
            setSelectedDeviceCode('لا يوجد/لايوجد');
          } else {
            setSelectedDeviceCode(location?.state?.account?.cf?.cf_rmz_aljhaz);
          }
          if (
            agentNameContext.length > 0 &&
            agentNameContext != undefined &&
            agentNameContext != null &&
            agentNameContext != ''
          ) {
            setValue('updatedBy', agentNameContext, {
              shouldValidate: true,
            });
          } else {
            let agentName = localStorage.getItem('agentName');
            setValue('updatedBy', agentName, {
              shouldValidate: true,
            });
          }
        }
      });

      // setLoadding(false);
    } catch (error) {
      console.log(error);
      // setError(error.message);
    }
  }, []);

  useEffect(() => {
    console.log(errors);
  }, [errors]);
  useEffect(() => {
    setValue('city', selectedCity?.name, {
      shouldValidate: true,
    });
    setValue('suburb', selectedSuburb?.name, {
      shouldValidate: true,
    });

    setValue('accountType', selectedAccountType, {
      shouldValidate: true,
    });
    setValue('cf_nw_alastfsar', selectedInquiryTypes, {
      shouldValidate: true,
    });
    setValue('status', selectedPerson, {
      shouldValidate: true,
    });
    setValue('cf_altlb', selectedRequsetType, {
      shouldValidate: true,
    });
    // setValue('cf_nw_rmzAljhaz', selectedDeviceCode, {
    //   shouldValidate: true,
    // });
  }, [
    selectedCity,
    selectedSuburb,
    selectedInquiryTypes,
    // selectedDeviceType,
    selectedRequsetType,
    selectedAccountType,
    // selectedDeviceCode,
    selectedPerson,
  ]);
  // useEffect(() => {
  //   deviceCodesx = selectedDeviceType?.deviceCodes;
  //   setSelectedDeviceCode(deviceCodesx[0]);
  // }, [selectedDeviceType]);
  useEffect(() => {
    if (xx?.length > 0 && selectedCity?.name !== xx) {
      setSelectedSuburb(
        selectedCity?.Suburbs.find((element) => element?.name === xx)
      );
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ['ar']);
        });
      } else {
        suburbs = [selectedCity];
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ['ar']);
        });
        setSelectedSuburb(suburbs[0]);
      }
    } else {
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ['ar']);
        });
        setSelectedSuburb(suburbs[0]);
      } else {
        suburbs = [selectedCity];
        setSelectedSuburb(suburbs[0]);
      }
    }
  }, [selectedCity]);
  return (
    <div
      className='bg-background-100 h-full min-h-screen w-full flex flex-col container px-36 py-20'
      dir='rtl'
    >
      {
        <SubmitModalInquiry
          open={open}
          setOpen={setOpen}
          phoneNumber={phoneNumber}
          setError={setError}
          setDone={setDone}
        />
      }
      {
        <SubmitModalStore
          open={openStore}
          setOpen={setOpenStore}
          phoneNumber={phoneNumber}
          setError={setError}
          setDone={setDoneStore}
        />
      }
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className='mx-auto '>
          <p className='text-title-100 text-xl font-bold'>
            رقم التذكرة: {location?.state?.account?.ticketNumber}
          </p>
        </div>

        <div className='pt-14 justify-between flex '>
          <p className='text-title-100 text-xl '>
            التاريخ: {location?.state?.account?.createdTime?.split('T')[0]}
          </p>
        </div>
        <div className='pt-4 justify-between flex '>
          <p className='text-title-100 text-xl '>أمر العمل: {id}</p>
        </div>
        <div className='grid grid-cols-3 gap-44'>
          <div className='flex  pt-12'>
            <div className='w-80  '>
              <Listbox
                as='div'
                className='space-y-1'
                value={selectedPerson}
                onChange={setSelectedPerson}
              >
                {({ open }) => (
                  <>
                    <Listbox.Label className='block  leading-5 text-title-100 text-xl pb-4'>
                      حالة النموذج
                    </Listbox.Label>
                    <div className='relative'>
                      <span className='inline-block w-full rounded-md shadow-sm'>
                        <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                          <span className='block truncate'>
                            {selectedPerson}
                          </span>
                          <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                            <svg
                              className='h-5 w-5 text-gray-400'
                              viewBox='0 0 20 20'
                              fill='none'
                              stroke='currentColor'
                            >
                              <path
                                d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                            </svg>
                          </span>
                        </Listbox.Button>
                      </span>

                      <Transition
                        show={open}
                        leave='transition ease-in duration-100'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                        className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                      >
                        <Listbox.Options
                          static
                          className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                        >
                          {people.map((person) => (
                            <Listbox.Option key={person} value={person}>
                              {({ selected, active }) => (
                                <div
                                  className={`${active
                                      ? 'text-white bg-blue-600'
                                      : 'text-gray-900'
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                >
                                  <span
                                    className={`${selected ? 'font-semibold' : 'font-normal'
                                      } block truncate`}
                                  >
                                    {person}
                                  </span>
                                  {selected && (
                                    <span
                                      className={`${active ? 'text-white' : 'text-blue-600'
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                    >
                                      <svg
                                        className='h-5 w-5'
                                        xmlns='http://www.w3.org/2000/svg'
                                        viewBox='0 0 20 20'
                                        fill='currentColor'
                                      >
                                        <path
                                          fillRule='evenodd'
                                          d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                          clipRule='evenodd'
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </div>
          </div>
          <div className='flex  pt-12'>
            <div className='w-80  '>
              <Listbox
                as='div'
                className='space-y-1'
                value={selectedInquiryTypes}
                onChange={setSelectedInquiryTypes}
              >
                {({ open }) => (
                  <>
                    <Listbox.Label className='block  leading-5 text-title-100 text-xl pb-4'>
                      نوع الاستفسار
                    </Listbox.Label>
                    <div className='relative'>
                      <span className='inline-block w-full rounded-md shadow-sm'>
                        <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                          <span className='block truncate'>
                            {selectedInquiryTypes}
                          </span>
                          <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                            <svg
                              className='h-5 w-5 text-gray-400'
                              viewBox='0 0 20 20'
                              fill='none'
                              stroke='currentColor'
                            >
                              <path
                                d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                            </svg>
                          </span>
                        </Listbox.Button>
                      </span>

                      <Transition
                        show={open}
                        leave='transition ease-in duration-100'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                        className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                      >
                        <Listbox.Options
                          static
                          className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                        >
                          {inquiryTypes.map((person) => (
                            <Listbox.Option key={person} value={person}>
                              {({ selected, active }) => (
                                <div
                                  className={`${active
                                      ? 'text-white bg-blue-600'
                                      : 'text-gray-900'
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                >
                                  <span
                                    className={`${selected ? 'font-semibold' : 'font-normal'
                                      } block truncate`}
                                  >
                                    {person}
                                  </span>
                                  {selected && (
                                    <span
                                      className={`${active ? 'text-white' : 'text-blue-600'
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                    >
                                      <svg
                                        className='h-5 w-5'
                                        xmlns='http://www.w3.org/2000/svg'
                                        viewBox='0 0 20 20'
                                        fill='currentColor'
                                      >
                                        <path
                                          fillRule='evenodd'
                                          d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                          clipRule='evenodd'
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </div>
          </div>
          <div className="pt-12">

            <label htmlFor="" className=" text-title-100 text-md">
              <span className="px-1">مصدر التذكرة</span>
            </label>
            <input
              name="tktSource"
              disabled
              value={tktSource || "مكالمة هاتفية"}
              type="tktSource"
              className="w-full p-2 border border-gray-300 rounded mt-1"
            />
            <p className=" opacity-50 text-s">
              {errors?.serviceRequestType?.message}
            </p>
          </div>
        </div>
        <div className='py-12'>
          <p className='text-title-100 text-xl'>بيانات العميل</p>
        </div>
        <>
          <div className='flex flex-col space-y-4 '>
            <div className='grid grid-cols-2 gap-44'>
              <div>
                <label htmlFor='' className=' text-title-100 text-md block'>
                  <span className='px-1'>رقم العميل</span>
                </label>
                <input
                  name='accountCode'
                  disabled
                  {...register('accountCode')}
                  type='accountCode'
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                />
                <p className=' opacity-50 text-s'>
                  {errors?.accountCode?.message}
                </p>
              </div>
              <div className='flex '>
                <div className='w-full  '>
                  <Listbox
                    as='div'
                    className='space-y-1'
                    value={selectedAccountType}
                    onChange={setSelectedAccountType}
                  >
                    {({ open }) => (
                      <>
                        <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                          نوع الحساب
                        </Listbox.Label>
                        <div className='relative'>
                          <span className='inline-block w-full rounded-md shadow-sm'>
                            <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                              <span className='block truncate'>
                                {selectedAccountType}
                              </span>
                              <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                <svg
                                  className='h-5 w-5 text-gray-400'
                                  viewBox='0 0 20 20'
                                  fill='none'
                                  stroke='currentColor'
                                >
                                  <path
                                    d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                    strokeWidth='1.5'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                  />
                                </svg>
                              </span>
                            </Listbox.Button>
                          </span>

                          <Transition
                            show={open}
                            leave='transition ease-in duration-100'
                            leaveFrom='opacity-100'
                            leaveTo='opacity-0'
                            className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                          >
                            <Listbox.Options
                              static
                              className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                            >
                              {accountTypes.map((city) => (
                                <Listbox.Option
                                  key={city.name}
                                  value={city.name}
                                >
                                  {({ selected, active }) => (
                                    <div
                                      className={`${active
                                          ? 'text-white bg-blue-600'
                                          : 'text-gray-900'
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                    >
                                      <span
                                        className={`${selected
                                            ? 'font-semibold'
                                            : 'font-normal'
                                          } block truncate`}
                                      >
                                        {city.name}
                                      </span>
                                      {selected && (
                                        <span
                                          className={`${active
                                              ? 'text-white'
                                              : 'text-blue-600'
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                        >
                                          <svg
                                            className='h-5 w-5'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'
                                          >
                                            <path
                                              fillRule='evenodd'
                                              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                              clipRule='evenodd'
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
              </div>{' '}
            </div>
            <div className='grid grid-cols-2 gap-44'>
              <div>
                <label htmlFor='' className=' text-title-100 text-md block'>
                  <span className='px-1'>الاسم</span>
                </label>
                <input
                  name='clientName'
                  {...register('clientName')}
                  type='clientName'
                  disabled
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                />
                <p className=' opacity-50 text-s'>
                  {errors?.clientName?.message}
                </p>
              </div>
              <div>
                <label htmlFor='' className=' text-title-100 text-md block'>
                  <span className='px-1'>رقم الهاتف</span>
                </label>
                <input
                  name='phone'
                  {...register('phone')}
                  type='phone'
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                />
                <p className=' opacity-50 text-s'>{errors?.phone?.message}</p>
              </div>
            </div>
            <div className='grid grid-cols-2 gap-44'>
              <div className='flex '>
                <div className='w-full  z-30'>
                  <Listbox
                    as='div'
                    className='space-y-1'
                    value={selectedCity}
                    onChange={setSelectedCity}
                  >
                    {({ open }) => (
                      <>
                        <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                          المدينة
                        </Listbox.Label>
                        <div className='relative'>
                          <span className='inline-block w-full rounded-md shadow-sm'>
                            <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                              <span className='block truncate'>
                                {selectedCity?.name}
                              </span>
                              <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                <svg
                                  className='h-5 w-5 text-gray-400'
                                  viewBox='0 0 20 20'
                                  fill='none'
                                  stroke='currentColor'
                                >
                                  <path
                                    d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                    strokeWidth='1.5'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                  />
                                </svg>
                              </span>
                            </Listbox.Button>
                          </span>

                          <Transition
                            show={open}
                            leave='transition ease-in duration-100'
                            leaveFrom='opacity-100'
                            leaveTo='opacity-0'
                            className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                          >
                            <Listbox.Options
                              static
                              className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                            >
                              {citys?.map((person) => (
                                <Listbox.Option
                                  key={person?.name}
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <div
                                      className={`${active
                                          ? 'text-white bg-blue-600'
                                          : 'text-gray-900'
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                    >
                                      <span
                                        className={`${selected
                                            ? 'font-semibold'
                                            : 'font-normal'
                                          } block truncate`}
                                      >
                                        {person?.name}
                                      </span>
                                      {selected && (
                                        <span
                                          className={`${active
                                              ? 'text-white'
                                              : 'text-blue-600'
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                        >
                                          <svg
                                            className='h-5 w-5'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'
                                          >
                                            <path
                                              fillRule='evenodd'
                                              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                              clipRule='evenodd'
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
              </div>{' '}
              <div className='flex  '>
                <div className='w-full  z-30'>
                  <Listbox
                    as='div'
                    className='space-y-1'
                    value={selectedSuburb}
                    onChange={setSelectedSuburb}
                  >
                    {({ open }) => (
                      <>
                        <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                          الضاحية
                        </Listbox.Label>
                        <div className='relative'>
                          <span className='inline-block w-full rounded-md shadow-sm'>
                            <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                              <span className='block truncate'>
                                {selectedSuburb?.name}
                              </span>
                              <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                <svg
                                  className='h-5 w-5 text-gray-400'
                                  viewBox='0 0 20 20'
                                  fill='none'
                                  stroke='currentColor'
                                >
                                  <path
                                    d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                    strokeWidth='1.5'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                  />
                                </svg>
                              </span>
                            </Listbox.Button>
                          </span>

                          <Transition
                            show={open}
                            leave='transition ease-in duration-100'
                            leaveFrom='opacity-100'
                            leaveTo='opacity-0'
                            className=' absolute mt-1 w-full rounded-md bg-white shadow-lg'
                          >
                            <Listbox.Options
                              static
                              className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                            >
                              {suburbs?.map((person) => (
                                <Listbox.Option
                                  key={person?.name}
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <div
                                      className={`${active
                                          ? 'text-white bg-blue-600'
                                          : 'text-gray-900'
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                    >
                                      <span
                                        className={`${selected
                                            ? 'font-semibold'
                                            : 'font-normal'
                                          } block truncate`}
                                      >
                                        {person?.name}
                                      </span>
                                      {selected && (
                                        <span
                                          className={`${active
                                              ? 'text-white'
                                              : 'text-blue-600'
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                        >
                                          <svg
                                            className='h-5 w-5'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'
                                          >
                                            <path
                                              fillRule='evenodd'
                                              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                              clipRule='evenodd'
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
              </div>
            </div>

            <div className='py-8'>
              <p className='text-title-100 text-xl'>بيانات الخدمة</p>
            </div>
            <div className='grid grid-cols-2 gap-44'>
              {/* <div className='flex '>
                <div className='w-full z-10 '>
                  <Listbox
                    as='div'
                    className='space-y-1'
                    value={selectedDeviceType}
                    onChange={setSelectedDeviceType}
                  >
                    {({ open }) => (
                      <>
                        <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                          نوع الجهاز
                        </Listbox.Label>
                        <div className='relative'>
                          <span className='inline-block w-full rounded-md shadow-sm'>
                            <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                              <span className='block truncate'>
                                {selectedDeviceType?.name}
                              </span>
                              <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                <svg
                                  className='h-5 w-5 text-gray-400'
                                  viewBox='0 0 20 20'
                                  fill='none'
                                  stroke='currentColor'
                                >
                                  <path
                                    d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                    strokeWidth='1.5'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                  />
                                </svg>
                              </span>
                            </Listbox.Button>
                          </span>

                          <Transition
                            show={open}
                            leave='transition ease-in duration-100'
                            leaveFrom='opacity-100'
                            leaveTo='opacity-0'
                            className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                          >
                            <Listbox.Options
                              static
                              className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5 '
                            >
                              {deviceTypes.map((person) => (
                                <Listbox.Option
                                  key={person.name}
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <div
                                      className={`${
                                        active
                                          ? 'text-white bg-blue-600'
                                          : 'text-gray-900'
                                      } cursor-default select-none relative py-2 pl-8 pr-4`}
                                    >
                                      <span
                                        className={`${
                                          selected
                                            ? 'font-semibold'
                                            : 'font-normal'
                                        } block truncate`}
                                      >
                                        {person.name}
                                      </span>
                                      {selected && (
                                        <span
                                          className={`${
                                            active
                                              ? 'text-white'
                                              : 'text-blue-600'
                                          } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                        >
                                          <svg
                                            className='h-5 w-5'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'
                                          >
                                            <path
                                              fillRule='evenodd'
                                              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                              clipRule='evenodd'
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
              </div>{' '} */}
              <div className='flex max-h-12'>
                <label htmlFor='' className=' text-title-100 text-md block'>
                  <span className='px-1'>نوع الجهاز</span>
                </label>
                <input
                  name='cf_nw_aljhaz'
                  disabled
                  {...register('cf_nw_aljhaz')}
                  type='text'
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                />
                <p className=' opacity-50 text-s'>
                  {errors?.cf_nw_aljhaz?.message}
                </p>
              </div>
              <div className=' '>
                <label htmlFor='' className=' text-title-100 text-md block'>
                  <span className='px-1'>اسم الجهاز</span>
                </label>
                <input
                  name='cf_nw_rmzAljhaz'
                  disabled
                  // {...register('cf_nw_rmzAljhaz')}
                  value={selectedDeviceCode.split('/')[0] || ' '}
                  type='text'
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                />
                <input
                  name='cf_nw_rmzAljhaz_1'
                  disabled
                  value={selectedDeviceCode.split('/')[1] || ' '}
                  type='text'
                  className='w-full p-2 border border-gray-300 rounded mt-1'
                />
                <p className=' opacity-50 text-s'>
                  {errors?.cf_nw_rmzAljhaz?.message}
                </p>
              </div>
            </div>
            <div className='grid grid-cols-2 gap-44 '>
              <div className='flex'>
                <div className='w-64'>
                  <Listbox
                    as='div'
                    className='space-y-1'
                    value={selectedRequsetType}
                    onChange={setSelectedRequsetType}
                  >
                    {({ open }) => (
                      <>
                        <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                          الطلب
                        </Listbox.Label>
                        <div className='relative'>
                          <span className='inline-block w-full rounded-md shadow-sm'>
                            <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                              <span className='block truncate'>
                                {selectedRequsetType}
                              </span>
                              <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                <svg
                                  className='h-5 w-5 text-gray-400'
                                  viewBox='0 0 20 20'
                                  fill='none'
                                  stroke='currentColor'
                                >
                                  <path
                                    d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                    strokeWidth='1.5'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                  />
                                </svg>
                              </span>
                            </Listbox.Button>
                          </span>

                          <Transition
                            show={open}
                            leave='transition ease-in duration-100'
                            leaveFrom='opacity-100'
                            leaveTo='opacity-0'
                            className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                          >
                            <Listbox.Options
                              static
                              className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                            >
                              {requsetTypes.map((person) => (
                                <Listbox.Option key={person} value={person}>
                                  {({ selected, active }) => (
                                    <div
                                      className={`${active
                                          ? 'text-white bg-blue-600'
                                          : 'text-gray-900'
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                    >
                                      <span
                                        className={`${selected
                                            ? 'font-semibold'
                                            : 'font-normal'
                                          } block truncate`}
                                      >
                                        {person}
                                      </span>
                                      {selected && (
                                        <span
                                          className={`${active
                                              ? 'text-white'
                                              : 'text-blue-600'
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                        >
                                          <svg
                                            className='h-5 w-5'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'
                                          >
                                            <path
                                              fillRule='evenodd'
                                              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                              clipRule='evenodd'
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
              </div>
            </div>
            <div className='grid grid-cols-2 gap-44 '>
              <div className='col-span-2'>
                <label
                  htmlFor=''
                  className=' text-title-100 text-md block pb-4'
                >
                  <span className='text-title-100 text-xl '>ملاحظات</span>
                </label>
                <textarea
                  rows='6'
                  className='block p-2.5 w-full bg-white text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 '
                  placeholder='ملاحظات'
                  name='notes'
                  {...register('notes')}
                ></textarea>
                <p className=' opacity-50 text-s'>{errors?.notes?.message}</p>
              </div>
            </div>
            <div className='grid grid-cols-2 gap-44'>
              <div className='col-span-2'>
                <label htmlFor='' className=' text-title-100 text-md block '>
                  <span className='px-1 '>ملاحظات 2</span>
                </label>
                <textarea
                  rows='4'
                  className='block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 '
                  placeholder=''
                  name='notes2'
                  {...register('notes2')}
                ></textarea>
                <p className=' opacity-50 text-s'>{errors?.notes2?.message}</p>
              </div>
            </div>
            <div className='grid grid-cols-2 gap-44'>
              <div className='col-span-2'>
                <label htmlFor='' className=' text-title-100 text-md block '>
                  <span className='px-1 '>ملاحظات 3</span>
                </label>
                <textarea
                  rows='4'
                  className='block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 '
                  placeholder=''
                  name='notes3'
                  {...register('notes3')}
                ></textarea>
                <p className=' opacity-50 text-s'>{errors?.notes3?.message}</p>
              </div>
            </div>
            {!done && (
              <div className='flex flex-row justify-end' dir='ltr'>
                <Switch
                  checked={open}
                  onChange={setOpen}
                  className={`${open ? 'bg-blue-600' : 'bg-gray-200'
                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                >
                  <span className='sr-only'>Enable notifications</span>
                  <span
                    className={`${open ? 'translate-x-6' : 'translate-x-1'
                      } inline-block h-4 w-4 transform rounded-full bg-white`}
                  />
                </Switch>
                <p className='pl-4'>ارسال رسالة نصية للزبون </p>
              </div>
            )}
            {!doneStore && (
              <div className='flex flex-row justify-end' dir='ltr'>
                <Switch
                  checked={openStore}
                  onChange={setOpenStore}
                  className={`${openStore ? 'bg-blue-600' : 'bg-gray-200'
                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                >
                  <span className='sr-only'>Enable notifications</span>
                  <span
                    className={`${openStore ? 'translate-x-6' : 'translate-x-1'
                      } inline-block h-4 w-4 transform rounded-full bg-white`}
                  />
                </Switch>
                <p className='pl-4'>ارسال مراكز البيع للزبون</p>
              </div>
            )}
          </div>

          <div className='pt-14 justify-center flex'>
            {
              <button
                type='submit'
                className='text-white bg-button-100    font-medium  text-sm px-10 py-2.5 mr-2 mb-2   rounded '
              // onClick={() => signupHandler(ticket)}
              >
                تعديل
              </button>
            }
            <button
              type='button'
              className='bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white  border border-blue-500 hover:border-transparent rounded text-sm px-6 py-2.5 mr-2 mb-2    '
              onClick={() => signupHandler()}
            >
              الإستمرار
            </button>
          </div>
        </>
      </form>
      <TailwindToaster />
    </div>
  );
};

export default UpdateInquiryFormScreen;
